import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export default function ViewportSync() {
  const location = useLocation()

  useEffect(() => {
    const setVar = () => {
      const height = (window.visualViewport?.height ?? window.innerHeight) * 0.01
      document.documentElement.style.setProperty("--app-vh", `${height}px`)
    }

    // Unlock any leftover scroll locks (e.g., from drawers/dialogs)
    document.documentElement.style.overflow = ""
    document.body.style.overflow = ""
    document.body.style.position = ""
    document.body.style.touchAction = ""

    // Ensure we set it ASAP and then in next frame
    setVar()
    const raf = requestAnimationFrame(setVar)
    return () => cancelAnimationFrame(raf)
  }, [location.pathname])

  return null
}
